module.exports = __webpack_public_path__ + "img/Klettergerüst.247500e4.svg";